
import crmService from "@/modules/CRM/services/crmService";

const funilInicial = () => ({
  id_crm_funil: null,
  nome: "",
  descricao: "",
  padrao: false,
  ativo: true,
  ordem: 0,
});

const etapaInicial = () => ({
  id_crm_etapa: null,
  id_crm_funil: null,
  nome: "",
  ordem: 0,
  probabilidade: 0,
  cor: "#3699ff",
  ativo: true,
  sugerir_tarefa: false,
  tarefa_sugerida_tipo: "tarefa",
  tarefa_sugerida_titulo: "",
  tarefa_sugerida_prazo_horas: 24,
  exigir_motivo_perda: false,
  destacar_sem_tarefa: true,
  alertar_oportunidade_parada: true,
  alerta_parada_dias: 7,
});

const itemInicial = () => ({
  nome: "",
  ativo: true,
});

const temperaturaInicial = () => ({
  id_crm_temperatura: null,
  nome: "",
  cor: "#3699ff",
  peso: 0,
  ativo: true,
});

const campoComercialInicial = () => ({
  id_crm_campo_comercial: null,
  nome: "",
  tipo: "texto",
  opcoes: "",
  obrigatorio: false,
  visivel_kanban: false,
  ativo: true,
  ordem: 0,
});

const automacaoInicial = () => ({
  id_crm_automacao: null,
  nome: "",
  descricao: "",
  escopo: "crm",
  prioridade: 0,
  ativo: false,
  max_execucoes_por_evento: 1,
  gatilho: "oportunidade_criada",
  condicoes: [],
  acoes: [
    {
      acao: "criar_timeline",
      parametros: { descricao: "Automação executada no CRM." },
      parametros_texto: '{"descricao":"Automação executada no CRM."}',
    },
  ],
});

const atribuicoesInicial = () => ({
  gestor: [],
  vendedor: [],
  desenvolvedor: [],
  website: [],
  treinamento: [],
});

const atribuicaoPapeis = [
  {
    chave: "gestor",
    nome: "Gestores",
    descricao: "Acompanham todos os cards e recebem os contratos.",
  },
  {
    chave: "vendedor",
    nome: "Vendedores",
    descricao: "Criam oportunidades e conduzem vendas e pós-venda.",
  },
  {
    chave: "desenvolvedor",
    nome: "Desenvolvedores",
    descricao: "Recebem apresentação técnica e implementação white label.",
  },
  {
    chave: "website",
    nome: "Website",
    descricao: "Recebem somente os cards do funil de website.",
  },
  {
    chave: "treinamento",
    nome: "Treinamento",
    descricao: "Recebem somente os cards do funil de treinamento.",
  },
];

export default {
  name: "crm-configuracoes",
  data() {
    return {
      loading: false,
      loadingAtribuicoes: false,
      loadingPreConfiguracoes: false,
      saving: false,
      selectedFunilId: null,
      acessosFunilForm: [],
      atribuicaoPapeis,
      atribuicoesForm: atribuicoesInicial(),
      usuariosAtribuicoes: [],
      preConfiguracoes: [],
      funis: [],
      fontes: [],
      motivos: [],
      tiposTarefa: [],
      temperaturas: [],
      camposComerciais: [],
      usuarios: [],
      automacoes: [],
      automacaoOpcoes: {
        gatilhos: [],
        condicoes: [],
        acoes: [],
        operadores: [],
        usuarios: [],
        funis: [],
        etapas: [],
        campos_comerciais: [],
      },
      automacaoExecucoes: [],
      automacaoSimulacao: {
        id_crm_oportunidade: null,
        resultado: null,
      },
      modalFunil: false,
      modalPreConfiguracoes: false,
      modalAtribuicoes: false,
      modalEtapa: false,
      modalFonte: false,
      modalMotivo: false,
      modalTipoTarefa: false,
      modalTemperatura: false,
      modalCampoComercial: false,
      funilForm: funilInicial(),
      etapaForm: etapaInicial(),
      fonteForm: itemInicial(),
      motivoForm: itemInicial(),
      tipoTarefaForm: itemInicial(),
      temperaturaForm: temperaturaInicial(),
      campoComercialForm: campoComercialInicial(),
      automacaoForm: automacaoInicial(),
    };
  },
  computed: {
    funisOrdenados() {
      return [...this.funis].sort((a, b) => {
        const ordemA = Number(a.ordem || 0);
        const ordemB = Number(b.ordem || 0);
        if (ordemA !== ordemB) {
          return ordemA - ordemB;
        }
        return String(a.nome || "").localeCompare(String(b.nome || ""));
      });
    },
    funilSelecionado() {
      return this.funisOrdenados.find(
        (funil) => funil.id_crm_funil === this.selectedFunilId
      );
    },
    etapasSelecionadas() {
      const etapas =
        this.funilSelecionado && this.funilSelecionado.etapas
          ? this.funilSelecionado.etapas
          : [];

      return [...etapas].sort(
        (a, b) => Number(a.ordem || 0) - Number(b.ordem || 0)
      );
    },
    funilOptions() {
      return this.funisOrdenados.map((funil) => ({
        value: funil.id_crm_funil,
        text: funil.nome,
      }));
    },
    usuarioOptionsSemTodos() {
      return this.usuarios.map((usuario) => ({
        value: usuario.id_usuario,
        text: usuario.nome || usuario.usuario,
      }));
    },
    usuarioAtribuicaoOptions() {
      const usuarios = this.usuariosAtribuicoes.length
        ? this.usuariosAtribuicoes
        : this.usuarios;

      return usuarios.map((usuario) => ({
        value: usuario.id_usuario,
        text: usuario.nome || usuario.usuario,
      }));
    },
    tipoTarefaOptions() {
      const ativos = this.tiposTarefa.filter((tipo) => tipo.ativo !== false);
      const tipos = ativos.length
        ? ativos
        : [{ nome: "Tarefa", chave: "tarefa" }];

      return tipos.map((tipo) => ({
        value: tipo.chave || this.slug(tipo.nome),
        text: tipo.nome,
      }));
    },
    tipoCampoOptions() {
      return [
        { value: "texto", text: "Texto" },
        { value: "numero", text: "Número" },
        { value: "data", text: "Data" },
        { value: "lista", text: "Lista" },
        { value: "booleano", text: "Sim/Não" },
      ];
    },
    automacaoGatilhoOptions() {
      return this.opcoesAutomacaoSelect("gatilhos");
    },
    automacaoCondicaoOptions() {
      return this.opcoesAutomacaoSelect("condicoes");
    },
    automacaoAcaoOptions() {
      return this.opcoesAutomacaoSelect("acoes");
    },
    automacaoOperadorOptions() {
      return this.opcoesAutomacaoSelect("operadores");
    },
    automacaoUsuarioOptions() {
      const usuariosAutomacao = this.automacaoOpcoes.usuarios || [];
      const usuarios = usuariosAutomacao.length
        ? usuariosAutomacao
        : this.usuarios;

      return usuarios.map((usuario) => ({
        value: usuario.id_usuario,
        text: usuario.nome || usuario.usuario,
      }));
    },
    automacaoUsuarioOptionsComVazio() {
      return [
        { value: null, text: "Manter atual / não definido" },
        ...this.automacaoUsuarioOptions,
      ];
    },
    automacaoFunilOptions() {
      const funisAutomacao = this.automacaoOpcoes.funis || [];
      const funis = funisAutomacao.length
        ? funisAutomacao
        : this.funisOrdenados;

      return funis.map((funil) => ({
        value: funil.id_crm_funil,
        text: funil.nome,
      }));
    },
    automacaoFunilOptionsComVazio() {
      return [
        { value: null, text: "Selecione um funil" },
        ...this.automacaoFunilOptions,
      ];
    },
    automacaoCampoOptions() {
      const camposAutomacao = this.automacaoOpcoes.campos_comerciais || [];
      const campos = camposAutomacao.length
        ? camposAutomacao
        : this.camposComerciais;

      return campos.map((campo) => ({
        value: campo.id_crm_campo_comercial,
        text: campo.nome,
        chave: campo.chave,
      }));
    },
    automacaoCampoOptionsComVazio() {
      return [
        { value: null, text: "Selecione um campo" },
        ...this.automacaoCampoOptions,
      ];
    },
  },
  mounted() {
    this.loadAll();
  },
  watch: {
    selectedFunilId() {
      this.syncAcessosFunilForm();
    },
  },
  methods: {
    async loadAll() {
      this.loading = true;

      try {
        const responses = await Promise.allSettled([
          crmService.funis({
            per_page: 100,
            incluir_etapas_inativas: true,
          }),
          crmService.fontesConfiguracao(),
          crmService.motivosPerdaConfiguracao(),
          crmService.tiposTarefaConfiguracao(),
          crmService.temperaturasConfiguracao(),
          crmService.camposComerciaisConfiguracao(),
          crmService.preConfiguracoesConfiguracao(),
          crmService.usuarios({
            per_page: 100,
            page: 1,
            sort: [{ field: "nome", type: "asc" }],
          }),
          crmService.automacoesOpcoes(),
          crmService.automacoes({ per_page: 100 }),
          crmService.automacaoExecucoes({ per_page: 8 }),
        ]);
        const [
          funis,
          fontes,
          motivos,
          tiposTarefa,
          temperaturas,
          camposComerciais,
          preConfiguracoes,
          usuarios,
          automacaoOpcoes,
          automacoes,
          automacaoExecucoes,
        ] = responses.map((response) =>
          response.status === "fulfilled" ? response.value : null
        );

        this.funis = this.normalizarColecao(funis);
        this.fontes = this.normalizarColecao(fontes);
        this.motivos = this.normalizarColecao(motivos);
        this.tiposTarefa = this.normalizarColecao(tiposTarefa);
        this.temperaturas = this.normalizarColecao(temperaturas);
        this.camposComerciais = this.normalizarColecao(camposComerciais);
        this.preConfiguracoes = this.normalizarColecao(preConfiguracoes);
        this.usuarios = this.normalizarColecao(usuarios);
        this.automacaoOpcoes = this.normalizarObjeto(
          automacaoOpcoes,
          this.automacaoOpcoes
        );
        this.automacoes = this.normalizarColecao(automacoes);
        this.automacaoExecucoes = this.normalizarColecao(automacaoExecucoes);
        this.manterFunilSelecionado();
        this.syncAcessosFunilForm();

        const falhas = responses.filter(
          (response) => response.status === "rejected"
        );
        if (falhas.length) {
          this.$toast.error(
            this.mensagemErro(
              falhas[0].reason,
              "Algumas configurações não puderam ser carregadas."
            )
          );
        }
      } catch (error) {
        this.$toast.error(
          this.mensagemErro(
            error,
            "Não foi possível carregar as configurações."
          )
        );
      } finally {
        this.loading = false;
      }
    },
    normalizarColecao(response) {
      const body =
        response && response.data !== undefined ? response.data : response;
      const data = body && body.data !== undefined ? body.data : body;

      if (Array.isArray(data)) {
        return data;
      }

      if (data && Array.isArray(data.data)) {
        return data.data;
      }

      return [];
    },
    normalizarObjeto(response, fallback = {}) {
      const body =
        response && response.data !== undefined ? response.data : response;
      const data = body && body.data !== undefined ? body.data : body;

      return data && typeof data === "object" && !Array.isArray(data)
        ? data
        : fallback;
    },
    manterFunilSelecionado() {
      if (
        this.selectedFunilId &&
        this.funis.some((funil) => funil.id_crm_funil === this.selectedFunilId)
      ) {
        return;
      }

      this.selectedFunilId = this.funisOrdenados.length
        ? this.funisOrdenados[0].id_crm_funil
        : null;
    },
    syncAcessosFunilForm() {
      const acessos =
        this.funilSelecionado && this.funilSelecionado.usuarios_acesso
          ? this.funilSelecionado.usuarios_acesso
          : [];

      this.acessosFunilForm = acessos
        .filter((acesso) => acesso.ativo !== false)
        .map((acesso) => Number(acesso.id_usuario));
    },
    abrirModalAtribuicoes() {
      this.modalAtribuicoes = true;
      this.loadAtribuicoes();
    },
    async loadAtribuicoes() {
      this.loadingAtribuicoes = true;

      try {
        const responses = await Promise.allSettled([
          crmService.atribuicoesConfiguracao(),
          crmService.usuariosAtribuicoesConfiguracao(),
        ]);
        const [atribuicoesResult, usuariosResult] = responses;
        const atribuicoesResponse =
          atribuicoesResult.status === "fulfilled"
            ? atribuicoesResult.value
            : null;
        const usuariosResponse =
          usuariosResult.status === "fulfilled" ? usuariosResult.value : null;
        const atribuicoesData = this.normalizarObjeto(atribuicoesResponse, {});
        const usuariosData = this.normalizarObjeto(usuariosResponse, {});

        this.usuariosAtribuicoes = Array.isArray(usuariosData.usuarios)
          ? usuariosData.usuarios
          : this.normalizarColecao(usuariosResponse);
        this.atribuicoesFromResponse(atribuicoesData);

        const falha = responses.find(
          (response) => response.status === "rejected"
        );
        if (falha) {
          this.$toast.error(
            this.mensagemErro(
              falha.reason,
              "Algumas informações de atribuições não puderam ser carregadas."
            )
          );
        }
      } catch (error) {
        this.$toast.error(
          this.mensagemErro(error, "Não foi possível carregar as atribuições.")
        );
      } finally {
        this.loadingAtribuicoes = false;
      }
    },
    atribuicoesFromResponse(data) {
      const origem = data && data.atribuicoes ? data.atribuicoes : {};
      const form = atribuicoesInicial();

      this.atribuicaoPapeis.forEach((papel) => {
        const itens = Array.isArray(origem[papel.chave])
          ? origem[papel.chave]
          : [];

        form[papel.chave] = itens
          .map((item) => Number(item.id_usuario || item))
          .filter(Boolean);
      });

      this.atribuicoesForm = form;
    },
    async salvarAtribuicoes() {
      this.saving = true;

      try {
        const payload = {
          atribuicoes: {},
        };

        this.atribuicaoPapeis.forEach((papel) => {
          payload.atribuicoes[papel.chave] = [
            ...new Set(
              (this.atribuicoesForm[papel.chave] || [])
                .map((idUsuario) => Number(idUsuario))
                .filter(Boolean)
            ),
          ];
        });

        const response = await crmService.salvarAtribuicoesConfiguracao(
          payload
        );
        const body = response && response.data ? response.data : response;

        if (body && body.status === false) {
          this.$toast.error(
            body.msg || "Não foi possível salvar as atribuições."
          );
          return;
        }

        this.atribuicoesFromResponse(body && body.data ? body.data : body);
        this.$toast.success("Atribuições salvas com sucesso.");
      } catch (error) {
        this.$toast.error(
          this.mensagemErro(error, "Não foi possível salvar as atribuições.")
        );
      } finally {
        this.saving = false;
      }
    },
    async salvarAcessosFunil() {
      if (!this.funilSelecionado) {
        this.$toast.error("Selecione um funil.");
        return;
      }

      const salvo = await this.executar(
        crmService.atualizarAcessosFunil({
          id_crm_funil: this.funilSelecionado.id_crm_funil,
          usuarios: this.acessosFunilForm,
        }),
        "Acessos do funil salvos com sucesso."
      );

      if (salvo && salvo.id_crm_funil) {
        this.selectedFunilId = salvo.id_crm_funil;
        this.syncAcessosFunilForm();
      }
    },
    proximaOrdemFunil() {
      return (
        this.funis.reduce(
          (maior, funil) => Math.max(maior, Number(funil.ordem || 0)),
          0
        ) + 1
      );
    },
    proximaOrdemEtapa(funil) {
      const etapas = funil && funil.etapas ? funil.etapas : [];
      return (
        etapas.reduce(
          (maior, etapa) => Math.max(maior, Number(etapa.ordem || 0)),
          0
        ) + 1
      );
    },
    novoFunil() {
      this.funilForm = {
        ...funilInicial(),
        ordem: this.proximaOrdemFunil(),
        padrao: this.funis.length === 0,
      };
      this.modalFunil = true;
    },
    editarFunil(funil) {
      this.funilForm = {
        id_crm_funil: funil.id_crm_funil,
        nome: funil.nome || "",
        descricao: funil.descricao || "",
        padrao: Boolean(funil.padrao),
        ativo: funil.ativo !== false,
        ordem: Number(funil.ordem || 0),
      };
      this.modalFunil = true;
    },
    async salvarFunil() {
      if (!this.funilForm.nome) {
        this.$toast.error("Informe o nome do funil.");
        return;
      }

      const payload = {
        ...this.funilForm,
        ordem: Number(this.funilForm.ordem || 0),
      };

      const request = payload.id_crm_funil
        ? crmService.atualizarFunil(payload)
        : crmService.criarFunil(payload);

      const salvo = await this.executar(request, "Funil salvo com sucesso.");
      if (salvo) {
        this.modalFunil = false;
        if (salvo.id_crm_funil) {
          this.selectedFunilId = salvo.id_crm_funil;
        }
      }
    },
    async apagarFunil(funil) {
      if (!funil || !funil.id_crm_funil) {
        return;
      }

      const confirmado = this.$bvModal
        ? await this.$bvModal.msgBoxConfirm(
            `Apagar o funil "${funil.nome}"? Esta ação não será permitida se houver cards abertos nesse funil.`,
            {
              title: "Apagar funil",
              okTitle: "Apagar",
              cancelTitle: "Cancelar",
              okVariant: "danger",
              cancelVariant: "light",
            }
          )
        : window.confirm(`Apagar o funil "${funil.nome}"?`);

      if (!confirmado) {
        return;
      }

      const salvo = await this.executar(
        crmService.apagarFunil({ id_crm_funil: funil.id_crm_funil }),
        "Funil apagado com sucesso."
      );

      if (salvo) {
        this.selectedFunilId = null;
        this.manterFunilSelecionado();
      }
    },
    novaEtapa(funil = this.funilSelecionado) {
      this.etapaForm = {
        ...etapaInicial(),
        id_crm_funil: funil ? funil.id_crm_funil : null,
        ordem: this.proximaOrdemEtapa(funil),
      };
      this.modalEtapa = true;
    },
    editarEtapa(etapa) {
      this.etapaForm = {
        id_crm_etapa: etapa.id_crm_etapa,
        id_crm_funil: etapa.id_crm_funil,
        nome: etapa.nome || "",
        ordem: Number(etapa.ordem || 0),
        probabilidade: Number(etapa.probabilidade || 0),
        cor: etapa.cor || "#3699ff",
        ativo: etapa.ativo !== false,
        sugerir_tarefa: Boolean(etapa.sugerir_tarefa),
        tarefa_sugerida_tipo: etapa.tarefa_sugerida_tipo || "tarefa",
        tarefa_sugerida_titulo: etapa.tarefa_sugerida_titulo || "",
        tarefa_sugerida_prazo_horas: Number(
          etapa.tarefa_sugerida_prazo_horas || 24
        ),
        exigir_motivo_perda: Boolean(etapa.exigir_motivo_perda),
        destacar_sem_tarefa: etapa.destacar_sem_tarefa !== false,
        alertar_oportunidade_parada:
          etapa.alertar_oportunidade_parada !== false,
        alerta_parada_dias: Number(etapa.alerta_parada_dias || 7),
      };
      this.modalEtapa = true;
    },
    async salvarEtapa() {
      if (!this.etapaForm.id_crm_funil) {
        this.$toast.error("Informe o funil.");
        return;
      }

      if (!this.etapaForm.nome) {
        this.$toast.error("Informe o nome da etapa.");
        return;
      }

      const payload = {
        ...this.etapaForm,
        ordem: Number(this.etapaForm.ordem || 0),
        probabilidade: Number(this.etapaForm.probabilidade || 0),
        tarefa_sugerida_prazo_horas:
          Number(this.etapaForm.tarefa_sugerida_prazo_horas || 0) || null,
        alerta_parada_dias: Number(this.etapaForm.alerta_parada_dias || 7),
      };

      const request = payload.id_crm_etapa
        ? crmService.atualizarEtapa(payload)
        : crmService.criarEtapa(payload);

      const salvo = await this.executar(request, "Etapa salva com sucesso.");
      if (salvo) {
        this.modalEtapa = false;
        this.selectedFunilId = payload.id_crm_funil;
      }
    },
    novaFonte() {
      this.fonteForm = itemInicial();
      this.modalFonte = true;
    },
    editarFonte(fonte) {
      this.fonteForm = {
        id_crm_fonte: fonte.id_crm_fonte,
        nome: fonte.nome || "",
        ativo: fonte.ativo !== false,
      };
      this.modalFonte = true;
    },
    async salvarFonte() {
      if (!this.fonteForm.nome) {
        this.$toast.error("Informe o nome da fonte.");
        return;
      }

      const request = this.fonteForm.id_crm_fonte
        ? crmService.atualizarFonte(this.fonteForm)
        : crmService.criarFonte(this.fonteForm);

      const salvo = await this.executar(request, "Fonte salva com sucesso.");
      if (salvo) {
        this.modalFonte = false;
      }
    },
    novoMotivo() {
      this.motivoForm = itemInicial();
      this.modalMotivo = true;
    },
    editarMotivo(motivo) {
      this.motivoForm = {
        id_crm_motivo_perda: motivo.id_crm_motivo_perda,
        nome: motivo.nome || "",
        ativo: motivo.ativo !== false,
      };
      this.modalMotivo = true;
    },
    async salvarMotivo() {
      if (!this.motivoForm.nome) {
        this.$toast.error("Informe o motivo de perda.");
        return;
      }

      const request = this.motivoForm.id_crm_motivo_perda
        ? crmService.atualizarMotivoPerda(this.motivoForm)
        : crmService.criarMotivoPerda(this.motivoForm);

      const salvo = await this.executar(request, "Motivo salvo com sucesso.");
      if (salvo) {
        this.modalMotivo = false;
      }
    },
    novoTipoTarefa() {
      this.tipoTarefaForm = itemInicial();
      this.modalTipoTarefa = true;
    },
    editarTipoTarefa(tipo) {
      this.tipoTarefaForm = {
        id_crm_tipo_tarefa: tipo.id_crm_tipo_tarefa,
        nome: tipo.nome || "",
        ativo: tipo.ativo !== false,
      };
      this.modalTipoTarefa = true;
    },
    async salvarTipoTarefa() {
      if (!this.tipoTarefaForm.nome) {
        this.$toast.error("Informe o tipo de tarefa.");
        return;
      }

      const request = this.tipoTarefaForm.id_crm_tipo_tarefa
        ? crmService.atualizarTipoTarefa(this.tipoTarefaForm)
        : crmService.criarTipoTarefa(this.tipoTarefaForm);

      const salvo = await this.executar(
        request,
        "Tipo de tarefa salvo com sucesso."
      );
      if (salvo) {
        this.modalTipoTarefa = false;
      }
    },
    novaTemperatura() {
      this.temperaturaForm = {
        ...temperaturaInicial(),
        peso: this.proximaOrdemTemperatura(),
      };
      this.modalTemperatura = true;
    },
    editarTemperatura(temperatura) {
      this.temperaturaForm = {
        id_crm_temperatura: temperatura.id_crm_temperatura,
        nome: temperatura.nome || "",
        cor: temperatura.cor || "#3699ff",
        peso: Number(temperatura.peso || 0),
        ativo: temperatura.ativo !== false,
      };
      this.modalTemperatura = true;
    },
    async salvarTemperatura() {
      if (!this.temperaturaForm.nome) {
        this.$toast.error("Informe a temperatura.");
        return;
      }

      const payload = {
        ...this.temperaturaForm,
        peso: Number(this.temperaturaForm.peso || 0),
      };
      const request = payload.id_crm_temperatura
        ? crmService.atualizarTemperatura(payload)
        : crmService.criarTemperatura(payload);

      const salvo = await this.executar(
        request,
        "Temperatura salva com sucesso."
      );
      if (salvo) {
        this.modalTemperatura = false;
      }
    },
    novoCampoComercial() {
      this.campoComercialForm = {
        ...campoComercialInicial(),
        ordem: this.proximaOrdemCampoComercial(),
      };
      this.modalCampoComercial = true;
    },
    editarCampoComercial(campo) {
      this.campoComercialForm = {
        id_crm_campo_comercial: campo.id_crm_campo_comercial,
        nome: campo.nome || "",
        tipo: campo.tipo || "texto",
        opcoes: campo.opcoes || "",
        obrigatorio: Boolean(campo.obrigatorio),
        visivel_kanban: Boolean(campo.visivel_kanban),
        ativo: campo.ativo !== false,
        ordem: Number(campo.ordem || 0),
      };
      this.modalCampoComercial = true;
    },
    async salvarCampoComercial() {
      if (!this.campoComercialForm.nome) {
        this.$toast.error("Informe o nome do campo comercial.");
        return;
      }

      const payload = {
        ...this.campoComercialForm,
        ordem: Number(this.campoComercialForm.ordem || 0),
      };
      const request = payload.id_crm_campo_comercial
        ? crmService.atualizarCampoComercial(payload)
        : crmService.criarCampoComercial(payload);

      const salvo = await this.executar(
        request,
        "Campo comercial salvo com sucesso."
      );
      if (salvo) {
        this.modalCampoComercial = false;
      }
    },
    abrirModalPreConfiguracoes() {
      this.modalPreConfiguracoes = true;
      this.loadPreConfiguracoes();
    },
    async loadPreConfiguracoes() {
      this.loadingPreConfiguracoes = true;

      try {
        const response = await crmService.preConfiguracoesConfiguracao();
        this.preConfiguracoes = this.normalizarColecao(response);
      } catch (error) {
        this.$toast.error(
          this.mensagemErro(
            error,
            "Não foi possível carregar as pré-configurações."
          )
        );
      } finally {
        this.loadingPreConfiguracoes = false;
      }
    },
    async instalarPreConfiguracao(preset) {
      if (!preset || preset.status_instalacao === "instalado") {
        return;
      }

      const salvo = await this.executar(
        crmService.instalarPresetConfiguracao({ preset: preset.chave }),
        `${preset.nome} instalada/atualizada com sucesso.`
      );

      if (salvo) {
        this.$toast.success(
          `${salvo.funis || 0} funis, ${salvo.etapas || 0} etapas e ${
            salvo.campos || 0
          } campos prontos. ${salvo.automacoes || 0} automações configuradas.`
        );
        await Promise.all([this.loadAll(), this.loadPreConfiguracoes()]);
      }
    },
    labelStatusPreConfiguracao(preset) {
      const status = preset?.status_instalacao || "nao_instalado";

      if (status === "instalado") {
        return "Instalado";
      }

      if (status === "incompleto") {
        return "Incompleto";
      }

      return "Não instalado";
    },
    variantStatusPreConfiguracao(preset) {
      const status = preset?.status_instalacao || "nao_instalado";

      if (status === "instalado") {
        return "success";
      }

      if (status === "incompleto") {
        return "warning";
      }

      return "secondary";
    },
    labelAcaoPreConfiguracao(preset) {
      const status = preset?.status_instalacao || "nao_instalado";

      if (status === "instalado") {
        return "Instalado";
      }

      if (status === "incompleto") {
        return "Atualizar";
      }

      return "Instalar";
    },
    novaAutomacao() {
      this.automacaoForm = automacaoInicial();
      this.automacaoSimulacao.resultado = null;
    },
    editarAutomacao(automacao) {
      const gatilho =
        automacao.gatilhos && automacao.gatilhos.length
          ? automacao.gatilhos[0].gatilho
          : "oportunidade_criada";

      this.automacaoForm = {
        id_crm_automacao: automacao.id_crm_automacao,
        nome: automacao.nome || "",
        descricao: automacao.descricao || "",
        escopo: automacao.escopo || "crm",
        prioridade: Number(automacao.prioridade || 0),
        ativo: Boolean(automacao.ativo),
        max_execucoes_por_evento: Number(
          automacao.max_execucoes_por_evento || 1
        ),
        gatilho,
        condicoes: (automacao.condicoes || []).map((condicao) => ({
          campo: condicao.campo || "status",
          operador: condicao.operador || "igual",
          valor: this.valorCondicaoTexto(condicao.valor),
        })),
        acoes: (automacao.acoes && automacao.acoes.length
          ? automacao.acoes
          : [{ acao: "criar_timeline", parametros: null }]
        ).map((acao) => this.acaoAutomacaoForm(acao)),
      };
      this.automacaoSimulacao.resultado = null;
    },
    acaoAutomacaoForm(acao) {
      const parametros = this.prepararParametrosAcao(
        acao.acao || "criar_timeline",
        acao.parametros
      );

      return {
        acao: acao.acao || "criar_timeline",
        parametros,
        parametros_texto: this.jsonTexto(parametros),
      };
    },
    adicionarCondicao() {
      this.automacaoForm.condicoes.push({
        campo: "status",
        operador: "igual",
        valor: "",
      });
    },
    removerCondicao(index) {
      this.automacaoForm.condicoes.splice(index, 1);
    },
    adicionarAcao() {
      this.automacaoForm.acoes.push(
        this.acaoAutomacaoForm({
          acao: "criar_timeline",
          parametros: { descricao: "Automação executada no CRM." },
        })
      );
    },
    removerAcao(index) {
      if (this.automacaoForm.acoes.length === 1) {
        return;
      }

      this.automacaoForm.acoes.splice(index, 1);
    },
    async salvarAutomacao() {
      if (!this.automacaoForm.nome) {
        this.$toast.error("Informe o nome da automação.");
        return;
      }

      if (!this.automacaoForm.gatilho) {
        this.$toast.error("Selecione um gatilho.");
        return;
      }

      const payload = this.automacaoPayload();
      if (!payload) {
        return;
      }

      const request = payload.id_crm_automacao
        ? crmService.atualizarAutomacao(payload)
        : crmService.criarAutomacao(payload);

      const salvo = await this.executar(
        request,
        "Automação salva com sucesso."
      );
      if (salvo) {
        this.editarAutomacao(salvo);
      }
    },
    async alternarStatusAutomacao(automacao) {
      const ativo = !automacao.ativo;
      const salvo = await this.executar(
        crmService.alterarStatusAutomacao({
          id_crm_automacao: automacao.id_crm_automacao,
          ativo,
        }),
        ativo
          ? "Automação ativada com sucesso."
          : "Automação inativada com sucesso."
      );

      if (
        salvo &&
        this.automacaoForm.id_crm_automacao === automacao.id_crm_automacao
      ) {
        this.editarAutomacao(salvo);
      }
    },
    async excluirAutomacao(automacao) {
      const confirmado = this.$bvModal
        ? await this.$bvModal.msgBoxConfirm(
            `Excluir a automação "${automacao.nome}"? O histórico de execuções será preservado.`,
            {
              title: "Excluir automação",
              okTitle: "Excluir",
              cancelTitle: "Cancelar",
              okVariant: "danger",
              cancelVariant: "light",
            }
          )
        : window.confirm(`Excluir a automação "${automacao.nome}"?`);

      if (!confirmado) {
        return;
      }

      const removida = await this.executar(
        crmService.apagarAutomacao({
          id_crm_automacao: automacao.id_crm_automacao,
        }),
        "Automação excluída com sucesso."
      );

      if (
        removida &&
        this.automacaoForm.id_crm_automacao === automacao.id_crm_automacao
      ) {
        this.novaAutomacao();
      }
    },
    automacaoPayload() {
      const acoes = [];

      for (const acao of this.automacaoForm.acoes) {
        const parametros = this.sincronizarParametrosTexto(acao);
        if (!parametros) {
          return null;
        }

        acoes.push({
          acao: acao.acao,
          parametros,
          ativo: true,
        });
      }

      return {
        id_crm_automacao: this.automacaoForm.id_crm_automacao,
        nome: this.automacaoForm.nome,
        descricao: this.automacaoForm.descricao,
        escopo: this.automacaoForm.escopo || "crm",
        prioridade: Number(this.automacaoForm.prioridade || 0),
        ativo: Boolean(this.automacaoForm.ativo),
        max_execucoes_por_evento: Number(
          this.automacaoForm.max_execucoes_por_evento || 1
        ),
        gatilhos: [
          {
            gatilho: this.automacaoForm.gatilho,
            ativo: true,
            ordem: 1,
          },
        ],
        condicoes: this.automacaoForm.condicoes
          .filter((condicao) => condicao.campo)
          .map((condicao, index) => ({
            campo: condicao.campo,
            operador: condicao.operador || "igual",
            valor: condicao.valor,
            ativo: true,
            ordem: index + 1,
          })),
        acoes,
      };
    },
    prepararParametrosAcao(tipoAcao, parametrosOriginais) {
      const parametros =
        parametrosOriginais &&
        typeof parametrosOriginais === "object" &&
        !Array.isArray(parametrosOriginais)
          ? { ...parametrosOriginais }
          : {};

      if (tipoAcao === "criar_solicitacao_agenda_tecnica") {
        parametros.tipo_tarefa =
          parametros.tipo_tarefa || "apresentacao_tecnica";
        parametros.titulo = parametros.titulo || "Apresentação técnica";
        parametros.conceder_acesso_funil_tecnico =
          parametros.conceder_acesso_funil_tecnico !== false;
      }

      if (tipoAcao === "criar_tarefa") {
        parametros.titulo = parametros.titulo || "";
        parametros.tipo_tarefa = parametros.tipo_tarefa || "tarefa";
      }

      if (tipoAcao === "exigir_campo_antes_mover") {
        parametros.mensagem = parametros.mensagem || "";
        this.sincronizarCampoObrigatorioAcao({ parametros }, false);
      }

      if (tipoAcao === "atualizar_cliente") {
        parametros.campos_obrigatorios_texto = Array.isArray(
          parametros.campos_obrigatorios
        )
          ? parametros.campos_obrigatorios.join(", ")
          : parametros.campos_obrigatorios_texto || "";
      }

      if (tipoAcao === "enviar_link_agenda") {
        parametros.tipo_tarefa = parametros.tipo_tarefa || "tarefa";
        parametros.obrigatorio_para_concluir = Boolean(
          parametros.obrigatorio_para_concluir
        );
      }

      return parametros;
    },
    aoAlterarAcao(acao) {
      this.$set(
        acao,
        "parametros",
        this.prepararParametrosAcao(acao.acao, acao.parametros)
      );
      this.atualizarParametrosTexto(acao);
    },
    acaoTemDestino(acao) {
      return ["mover_funil", "criar_card_funil", "mover_etapa"].includes(
        acao.acao
      );
    },
    acaoTemAtribuicao(acao) {
      return [
        "criar_solicitacao_agenda_tecnica",
        "mover_funil",
        "criar_card_funil",
      ].includes(acao.acao);
    },
    labelAtribuicaoAcao(acao) {
      return acao.acao === "criar_solicitacao_agenda_tecnica"
        ? "Técnico da apresentação"
        : "Responsável pelo card";
    },
    acaoTemLiberacaoFunil(acao) {
      return [
        "criar_solicitacao_agenda_tecnica",
        "mover_funil",
        "criar_card_funil",
      ].includes(acao.acao);
    },
    automacaoEtapaOptionsPorFunil(idFunil) {
      const etapasAutomacao = this.automacaoOpcoes.etapas || [];
      const etapas = etapasAutomacao.length
        ? etapasAutomacao
        : this.funisOrdenados.flatMap((funil) => funil.etapas || []);
      const funil = idFunil ? Number(idFunil) : null;
      const filtradas = funil
        ? etapas.filter((etapa) => Number(etapa.id_crm_funil) === funil)
        : etapas;

      return [
        { value: null, text: "Selecione uma etapa" },
        ...filtradas.map((etapa) => ({
          value: etapa.id_crm_etapa,
          text: etapa.nome,
        })),
      ];
    },
    sincronizarCampoObrigatorioAcao(acao, atualizarTexto = true) {
      const parametros = acao.parametros || {};
      const idCampo = parametros.id_crm_campo_comercial;
      const camposAutomacao = this.automacaoOpcoes.campos_comerciais || [];
      const campos = camposAutomacao.length
        ? camposAutomacao
        : this.camposComerciais;
      const campo = campos.find(
        (item) => Number(item.id_crm_campo_comercial) === Number(idCampo)
      );

      if (campo) {
        this.$set(parametros, "campo", campo.chave);
      }

      if (atualizarTexto) {
        this.atualizarParametrosTexto(acao);
      }
    },
    atualizarCamposObrigatoriosAcao(acao) {
      const texto = acao.parametros.campos_obrigatorios_texto || "";
      this.$set(
        acao.parametros,
        "campos_obrigatorios",
        texto
          .split(",")
          .map((item) => item.trim())
          .filter(Boolean)
      );
      this.atualizarParametrosTexto(acao);
    },
    atualizarParametrosTexto(acao) {
      const parametros = this.normalizarParametrosAcao(acao);
      this.$set(acao, "parametros_texto", this.jsonTexto(parametros));

      return parametros;
    },
    sincronizarParametrosTexto(acao, usarTexto = false) {
      const parametrosTexto = this.parseJsonSeguro(acao.parametros_texto);
      if (parametrosTexto === false) {
        this.$toast.error("Revise o JSON dos parâmetros da ação.");
        return null;
      }

      const origem = usarTexto
        ? parametrosTexto
        : { ...parametrosTexto, ...(acao.parametros || {}) };
      const preparados = this.prepararParametrosAcao(acao.acao, origem);
      this.$set(acao, "parametros", preparados);

      return this.atualizarParametrosTexto(acao);
    },
    normalizarParametrosAcao(acao) {
      const parametros = { ...(acao.parametros || {}) };
      const numberKeys = [
        "id_usuario",
        "id_usuario_responsavel",
        "id_usuario_tecnico",
        "id_crm_funil_destino",
        "id_crm_etapa_destino",
        "id_crm_funil_tecnico",
        "id_crm_etapa_tecnico",
        "id_crm_campo_comercial",
      ];

      numberKeys.forEach((key) => {
        if (!Object.prototype.hasOwnProperty.call(parametros, key)) {
          return;
        }

        parametros[key] =
          parametros[key] === "" || parametros[key] === null
            ? null
            : Number(parametros[key]);
      });

      ["conceder_acesso_funil_tecnico", "obrigatorio_para_concluir"].forEach(
        (key) => {
          if (Object.prototype.hasOwnProperty.call(parametros, key)) {
            parametros[key] = Boolean(parametros[key]);
          }
        }
      );

      if (
        Object.prototype.hasOwnProperty.call(
          parametros,
          "campos_obrigatorios_texto"
        )
      ) {
        parametros.campos_obrigatorios = String(
          parametros.campos_obrigatorios_texto || ""
        )
          .split(",")
          .map((item) => item.trim())
          .filter(Boolean);
        delete parametros.campos_obrigatorios_texto;
      }

      Object.keys(parametros).forEach((key) => {
        if (parametros[key] === undefined) {
          delete parametros[key];
        }
      });

      return parametros;
    },
    async simularAutomacao() {
      if (!this.automacaoForm.gatilho) {
        this.$toast.error("Selecione um gatilho para simular.");
        return;
      }

      if (!this.automacaoSimulacao.id_crm_oportunidade) {
        this.$toast.error("Informe o ID da oportunidade.");
        return;
      }

      this.saving = true;

      try {
        const { data } = await crmService.executarAutomacao({
          gatilho: this.automacaoForm.gatilho,
          origem: "manual",
          simulacao: true,
          chave_evento: `simulacao:${Date.now()}`,
          payload: {
            id_crm_oportunidade: this.automacaoSimulacao.id_crm_oportunidade,
            simulacao: true,
          },
        });

        if (data && data.status === false) {
          this.$toast.error(data.msg || "Não foi possível simular.");
          return;
        }

        this.automacaoSimulacao.resultado = data.data || data;
        this.$toast.success("Simulação executada.");
        await this.loadAutomacaoExecucoes();
      } catch (error) {
        this.$toast.error(
          this.mensagemErro(error, "Não foi possível simular.")
        );
      } finally {
        this.saving = false;
      }
    },
    async loadAutomacaoExecucoes() {
      try {
        const response = await crmService.automacaoExecucoes({ per_page: 8 });
        this.automacaoExecucoes = this.normalizarColecao(response);
      } catch (error) {
        this.automacaoExecucoes = [];
        this.$toast.error("Não foi possível carregar o histórico.");
      }
    },
    opcoesAutomacaoSelect(tipo) {
      const opcoes = this.automacaoOpcoes[tipo] || [];

      return opcoes.map((item) => ({
        value: item.chave,
        text: item.nome || item.chave,
      }));
    },
    automacaoGatilhoResumo(automacao) {
      const gatilho =
        automacao.gatilhos && automacao.gatilhos.length
          ? automacao.gatilhos[0].gatilho
          : "";

      return this.automacaoGatilhoLabel(gatilho);
    },
    automacaoAcaoResumo(automacao) {
      const acoes = (automacao.acoes || [])
        .filter((acao) => acao.ativo !== false)
        .map((acao) => {
          const option = this.automacaoAcaoOptions.find(
            (item) => item.value === acao.acao
          );

          return option ? option.text : acao.acao;
        })
        .filter(Boolean);

      return acoes.length ? `Ações: ${acoes.join(", ")}` : "Sem ações";
    },
    automacaoGatilhoLabel(gatilho) {
      const option = this.automacaoGatilhoOptions.find(
        (item) => item.value === gatilho
      );

      return option ? option.text : gatilho || "Sem gatilho";
    },
    execucaoStatusVariant(status) {
      if (status === "sucesso") return "success";
      if (status === "erro") return "danger";
      if (status === "ignorada") return "warning";
      return "secondary";
    },
    valorCondicaoTexto(valor) {
      if (valor && typeof valor === "object" && "valor" in valor) {
        return valor.valor;
      }

      return valor || "";
    },
    jsonTexto(valor) {
      if (!valor) {
        return "{}";
      }

      try {
        return JSON.stringify(valor, null, 2);
      } catch (error) {
        return "{}";
      }
    },
    parseJsonSeguro(texto) {
      const value = String(texto || "").trim();

      if (!value) {
        return {};
      }

      try {
        return JSON.parse(value);
      } catch (error) {
        return false;
      }
    },
    formatDateTime(value) {
      if (!value) {
        return "-";
      }

      return new Date(value).toLocaleString("pt-BR");
    },
    etapaAutomacaoResumo(etapa) {
      const partes = [];

      if (etapa.sugerir_tarefa) {
        partes.push("sugere tarefa");
      }

      if (etapa.destacar_sem_tarefa) {
        partes.push("destaca sem tarefa");
      }

      if (etapa.alertar_oportunidade_parada) {
        partes.push(`alerta ${etapa.alerta_parada_dias || 7}d parada`);
      }

      if (etapa.exigir_motivo_perda) {
        partes.push("exige motivo");
      }

      return partes.length ? `Automação: ${partes.join(" · ")}` : "";
    },
    etapaCamposObrigatoriosResumo(etapa) {
      const obrigatorios = (etapa.campos_obrigatorios || []).filter(
        (item) => item.ativo !== false && item.campo
      );

      if (!obrigatorios.length) {
        return "";
      }

      const campos = obrigatorios
        .map((item) => item.campo.nome)
        .filter(Boolean)
        .slice(0, 4)
        .join(", ");

      return `Campos obrigatórios: ${campos}`;
    },
    proximaOrdemTemperatura() {
      return (
        this.temperaturas.reduce(
          (maior, item) => Math.max(maior, Number(item.peso || 0)),
          0
        ) + 1
      );
    },
    proximaOrdemCampoComercial() {
      return (
        this.camposComerciais.reduce(
          (maior, item) => Math.max(maior, Number(item.ordem || 0)),
          0
        ) + 1
      );
    },
    tipoCampoLabel(tipo) {
      const option = this.tipoCampoOptions.find((item) => item.value === tipo);

      return option ? option.text : tipo || "Texto";
    },
    slug(value) {
      return String(value || "item")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");
    },
    async executar(request, mensagem) {
      this.saving = true;

      try {
        const response = await request;
        const body = response && response.data ? response.data : response;

        if (body && body.status === false) {
          this.$toast.error(body.msg || "Não foi possível salvar.");
          return null;
        }

        this.$toast.success(mensagem);
        await this.loadAll();

        return body && body.data ? body.data : body;
      } catch (error) {
        this.$toast.error(this.mensagemErro(error, "Não foi possível salvar."));
        return null;
      } finally {
        this.saving = false;
      }
    },
    mensagemErro(error, padrao) {
      const response = error && error.response ? error.response.data : null;

      return (response && (response.msg || response.message)) || padrao;
    },
  },
};
